<ra-user-space-btn
  idleColor="primary"
  tooltipText="Разместить объявление"
  (click)="menuState = true"
  [active]="menuState"
>
  <svg width="24" height="24" viewBox="0 0 24 24"  fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75 12H20.25" stroke-width="2" stroke-linecap="round" stroke="#720AA4" stroke-linejoin="round"></path>
    <path d="M12 3.75V20.25" stroke-width="2" stroke-linecap="round" stroke="#720AA4" stroke-linejoin="round"></path>
  </svg>
</ra-user-space-btn>

<div
  *clientSideRendering
  class="absolute pt-2.5 z-50 transition-all -left-[210px]"
  [ngClass]="{
    'opacity-0 -translate-y-[5px] pointer-events-none': !menuState,
    'opacity-100 translate-y-0 pointer-events-auto': menuState,
  }"
>
  <div
    class="bg-white rounded-lg shadow flex-col justify-start items-start flex"
  >
    <div
      *ngFor="let link of links"
      class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
    >
      <a
        [href]="generateLink(link.link, link.queryParams)"
        (click)="menuState = false"
        class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap"
      >{{ link.name }}</a
      >
<!--      @if (link.reachGoal) {-->
<!--        <a-->
<!--          [routerLink]="link.link"-->
<!--          [queryParams]="link.queryParams"-->
<!--          (click)="menuState = false"-->
<!--          metrikaGoal-->
<!--          [goalName]="link.reachGoal"-->
<!--          class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap"-->
<!--        >{{ link.name }}</a-->
<!--        >-->
<!--      } @else {-->
<!--        <a-->
<!--          [routerLink]="link.link"-->
<!--          [queryParams]="link.queryParams"-->
<!--          (click)="menuState = false"-->
<!--          class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap"-->
<!--        >{{ link.name }}</a-->
<!--        >-->
<!--      }-->
    </div>
  </div>
</div>


